import { connect } from 'react-redux'
import Page from '../components/Page'

const mapStateToProps = (state, ownProps) => {
  const { width } = state.window
  return ({
    windowWidth: width
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Page)


// WEBPACK FOOTER //
// ./src/Parts/Page/containers/Page.js